import { useQuery } from "@tanstack/react-query"
import axios from "axios"
import type { Personnel } from "./types"

// Query keys
export const personnelKeys = {
  all: ["personnel"] as const,
  lists: () => [...personnelKeys.all, "list"] as const,
  list: (filters: Record<string, unknown>) => [...personnelKeys.lists(), { filters }] as const,
}

// Hook to fetch personnel with optional filters
export const usePersonnel = (filters?: Record<string, unknown>) => {
  return useQuery({
    queryKey: personnelKeys.list(filters || {}),
    queryFn: async () => {
      const response = await axios.get<{ personnel: Personnel[] }>("/api/myteconstruction/personnel", {
        params: filters,
      })
      return response.data.personnel
    },
  })
}

// Hook to fetch personnel by role
export const usePersonnelByRole = (role: string) => {
  return usePersonnel({ role })
}

// Hook to fetch active personnel
export const useActivePersonnel = (role?: string) => {
  return usePersonnel({ status: "active", role })
}
// Hook to fetch active, unseated personnel by role
export const useAvailablePersonnel = (role?: string) => {
  return usePersonnel({ role, available: true })
}
